import { useAuth, ROLES } from '../../contexts/AuthContext';
import { usePerspective } from '../../contexts/PerspectiveContext';
import WorkspaceSettings from '../dashboard/WorkspaceSettings';
import ConsultancySettings from '../consultant/ConsultancySettings';

// Role-aware settings router
export default function SettingsRouter() {
  const { user } = useAuth();
  const { getEffectiveRole, isInMockView } = usePerspective();
  
  // Get the effective role (considers perspective switching for Super Admin)
  const effectiveRole = getEffectiveRole();
  
  // Consultant sees Consultancy Settings (includes Super Admin in Consultant mock view)
  if (effectiveRole === ROLES.CONSULTANT) {
    return <ConsultancySettings />;
  }
  
  // Super Admin in their native view sees Consultancy Settings (their home org)
  if (user?.role === ROLES.SUPER_ADMIN && !isInMockView) {
    return <ConsultancySettings />;
  }
  
  // Contractor Admin sees Workspace Settings (Team Management)
  if (user?.role === ROLES.CONTRACTOR_ADMIN) {
    return <WorkspaceSettings />;
  }
  
  // Default to Workspace Settings for any other role with settings access
  return <WorkspaceSettings />;
}
